const allowedOrigins = [
  'https://app.growth99.com',
  'https://beta.growth99.com',
  'https://growth99.com',
];

const BASE_URL = allowedOrigins.includes(window.location.origin)
  ? window.location.origin
  : 'https://app.growth99.com';

export const environment = {
  production: true,
  apiUrls: {
    default: 'https://api-prod.growth99.com',
    public: 'https://public-api-prod.growth99.com',
    authApiUrl: 'https://api-prod.growth99.com',
    notificationApiUrl: 'https://g99-notify.growth99.com',
    formsInstagramApiUrl: 'https://api.growth99.com',
    aiServiceApiUrl: 'https://aiservice.growth99.com',
    scorecardApiUrl: 'https://scorecard.growth99.com/api',
    centralWsUrl: 'https://ws.growth99.com/ws',
  },
  webUrl: 'https://widget-ui.growth99.com',
  chatbotURL: 'https://chatbot.growth99.com',
  reviewDomain: 'https://reviews.growth99.com',
  ssrDomain: 'https://portal.growth99.com',
  ssrHost: 'portal.growth99.com',
  domainUrl: 'https://legacy-prod.growth99.com',
  adminAppUrl: 'https://admin.growth.com',
  emrUrl: 'https://app.growth99.com',
  ALLOW_USER_TO_OLD_UI: ['mehul.kothari@growth99.com'],

  // Business IDs where dental assessment should be hidden
  HIDE_DENTAL_ASSESSMENT_BUSINESS_IDS: [
    '6300',
    '688',
    '4202',
    '2939',
    '3931',
    '6200',
    '5623',
    '4944',
    '2405',
    '5685',
    '3461',
    '5183',
    '4457',
    '3166',
    '3168',
    '1786',
    '4216',
    '4705',
    '1752',
    '4646',
    '2055',
    '4479',
    '3167',
    '3231',
    '3891',
    '4191',
    '1583',
    '3594',
    '1607',
    '4357',
    '4542',
    '4232',
    '4349',
    '4935',
    '4645',
    '4606',
    '3169',
    '4529',
    '1552',
    '2902',
    '4307',
    '4223',
    '2386',
    '4470',
    '3927',
    '2869',
    '4358',
    '4917',
    '4344',
    '4309',
    '3170',
    '4348',
    '4420',
    '5608',
    '5738',
    '2801',
    '3765',
  ],

  GOOGLE_SOCIAL_PROFILE_CONNECT_URL: `https://accounts.google.com/o/oauth2/v2/auth?client_id=506679851055-2r6j3vkmu10use82mbtcl7dvqhe05ltc.apps.googleusercontent.com&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&response_type=code&scope=email%20profile%20https://www.googleapis.com/auth/business.manage&access_type=offline&prompt=consent&include_granted_scopes=false&state=channel_Google`,
  GOOGLE_PROFILE_CONNECT: `https://accounts.google.com/o/oauth2/v2/auth?client_id=506679851055-2r6j3vkmu10use82mbtcl7dvqhe05ltc.apps.googleusercontent.com&redirect_uri=${encodeURIComponent(BASE_URL + '/review/google-callback')}&response_type=code&scope=email%20profile%20https://www.googleapis.com/auth/business.manage&access_type=offline&prompt=consent&include_granted_scopes=false`,
  INSTAGRAM_PROFILE_CONNECT: `https://www.facebook.com/v23.0/dialog/oauth?client_id=641759040281574&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=instagram_basic,instagram_content_publish,pages_show_list,pages_messaging,instagram_manage_messages,pages_read_engagement,business_management,pages_manage_metadata,pages_read_user_content&response_type=token&state=channel_Instagram`,
  FACEBOOK_PROFILE_CONNECT_URL: `https://www.facebook.com/v23.0/dialog/oauth?client_id=641759040281574&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=pages_messaging,pages_show_list,pages_read_engagement,pages_manage_metadata,pages_manage_posts,pages_read_user_content,business_management,public_profile&response_type=token&state=channel_Facebook`,
  LINKEDIN_PROFILE_CONNECT_URL: `https://www.linkedin.com/oauth/v2/authorization?client_id=77xuvvbpv6uc93&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=openid,profile,email,w_member_social&response_type=code&state=channel_Linkedin`,
  SUPPORTED_FILE_TYPES_URL:
    'https://support.growth99.com/portal/en/kb/articles/instruction-guide-to-upload-files-in-the-file-manager',

  GOOGLE_SETUP: {
    clientId:
      '969333272286-l0j30jsg7f0hq53aehbj1ue70uc5ur4o.apps.googleusercontent.com',
    redirectUri:
      'https://app.growth99.com/active-agents/ai-gia/auth/google/callback',
    scopes: 'openid email profile https://www.googleapis.com/auth/calendar',
  },
  MAIL_DOMAIN: 'growth99-mail.com',
  enableGoogleCalendar: false,
  hubSpot: {
    portalId: '46303591',
    formId: '79b78cb1-8b09-4a63-9228-d0b83d5d8c06',
    region: 'na1',
  },
  mcp: {
    url: 'https://mcp.growth99.com/mcp',
    giaUrl: 'https://mcp.growth99.com/gia',
  },
};
